import { render } from "./HeaderComponent.vue?vue&type=template&id=45aa6591&scoped=true"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=45aa6591&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa6591"]])

export default __exports__